import { render, staticRenderFns } from "./profileInfo.vue?vue&type=template&id=fbcd1b96&scoped=true&"
import script from "./profileInfo.vue?vue&type=script&lang=js&"
export * from "./profileInfo.vue?vue&type=script&lang=js&"
import style0 from "./profileInfo.vue?vue&type=style&index=0&id=fbcd1b96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbcd1b96",
  null
  
)

export default component.exports